export default "__VITE_ASSET__5195da65__"